/**
 * R31 (2026-06-05) — Google Sign-in button (Emergent OAuth).
 *
 * Comportamento:
 * - Click → redirect a `https://auth.emergentagent.com/?redirect=<origin>/auth/google/callback`
 * - REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 *   (vedi playbook Emergent Auth — usa SEMPRE `window.location.origin`)
 * - Dopo OAuth, l'utente atterra su `<origin>/auth/google/callback#session_id=...`
 *   gestito dal componente `AuthCallback`.
 *
 * Props:
 *   - label: testo del bottone (default "Continua con Google")
 *   - intent: "login" | "signup" (puramente per testid/analytics)
 *   - disabled, className: standard
 */
import { Button } from "@/components/ui/button";

export default function GoogleSignInButton({
  label = "Continua con Google",
  intent = "login",
  disabled = false,
  className = "",
}) {
  const onClick = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
    // THIS BREAKS THE AUTH (playbook Emergent Auth)
    const redirectUrl = window.location.origin + "/auth/google/callback";
    // Salva l'intent (login vs signup) in sessionStorage così la pagina /completa-registrazione
    // può differenziare il messaggio se serve. Non firmato — solo UX hint.
    try { sessionStorage.setItem("haccp_google_auth_intent", intent); } catch { /* ignore */ }
    // Se siamo sulla landing e abbiamo già selezionato un pacchetto, persistilo.
    // /completa-registrazione lo userà come default selezionato.
    try {
      const pkg = sessionStorage.getItem("haccp_chosen_pkg");
      if (!pkg) sessionStorage.setItem("haccp_chosen_pkg", "completo");
    } catch { /* ignore */ }
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Button
      type="button"
      variant="outline"
      onClick={onClick}
      disabled={disabled}
      className={`w-full h-12 text-sm font-semibold bg-white hover:bg-slate-50 border-slate-300 text-slate-800 ${className}`}
      data-testid={`google-${intent}-btn`}
    >
      <GoogleIcon className="w-5 h-5 mr-2" />
      {label}
    </Button>
  );
}

function GoogleIcon({ className = "" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.1A6.6 6.6 0 0 1 5.48 12c0-.73.13-1.44.36-2.1V7.07H2.18A11 11 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.83z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.46 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.07l3.66 2.83C6.71 7.3 9.14 5.38 12 5.38z"/>
    </svg>
  );
}
